import { useLocalStorage } from '@buffer-mono/popcorn'

type SetLastItemCount = (count: number) => void

/**
 * The item count a Home section last resolved to, persisted so the section's
 * loading skeleton can reserve the same geometry on the next page load. This
 * is a rendering hint only — after the section's content changes it is wrong
 * for one load and then corrected.
 */
export function useLastItemCount(
  storageKey: string,
): [number | null, SetLastItemCount] {
  const [count, setCount] = useLocalStorage<number | null>(storageKey, null)
  return [count, setCount]
}
